
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aliados",
      function () {
        return require("private-next-pages/aliados/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aliados"])
      });
    }
  